import Papa from 'papaparse';

import { ISSUE_TYPE } from '@qality/common-config';
import { Issue, TestCaseTestSteps } from '@qality/common-model';

import type { ExportTestCaseFormat } from './ExportTestCasesContext';

export const getQAlityTypeIssues = (issues: Array<Issue>): Array<Issue> =>
  issues.filter((i) => {
    return i.fields.issuetype.name === ISSUE_TYPE.QALITY_TEST;
  });

export const formatData = (
  issues: Issue[],
  steps: TestCaseTestSteps[]
): ExportTestCaseFormat[] => {
  const result: ExportTestCaseFormat[] = [];

  issues.forEach((issue) => {
    const { fields } = issue;

    let testCaseWithSteps = steps.find((step) => step.testCaseId == issue.id);

    if (!testCaseWithSteps || testCaseWithSteps.steps.length === 0) {
      // Make empty step to show Test Case at export file
      testCaseWithSteps = {
        testCaseId: issue.id,
        steps: [
          {
            data: '',
            step: '',
            result: '',
          },
        ],
      };
    }

    testCaseWithSteps.steps.forEach((singleStep) => {
      result.push({
        'Issue Key': issue.key,
        'Test case name': fields.summary || '',
        Description: fields.description || '',
        'Test Step': singleStep.step || '',
        'Test Result': singleStep.result || '',
        'Test Data': singleStep.data || '',
      });
    });
  });

  return result;
};

export const parseJSONtoSCSV = (
  formattedJSONData: ExportTestCaseFormat[]
): string => {
  const csvData = Papa.unparse(formattedJSONData) as string;
  return csvData;
};

export const createCsvData = (
  issues: Issue[],
  steps: TestCaseTestSteps[]
): string => {
  const formatted = formatData(issues, steps);
  const csv = parseJSONtoSCSV(formatted);

  return csv;
};
